<template>
  <b-container fluid ref="exams">
    <b-row>
      <b-col class="top_bar" />
    </b-row>
    <b-row
      ><b-col><div class="page_title">Edit Exam</div></b-col></b-row
    >
    <Scantron
      :course-id="courseId"
      :question-categories="questionCategories"
      :exam="exam"
      :creating-exam="isAdmin"
    />
    <edit-exam-modal :course-id="courseId" :exam="exam" />
  </b-container>
</template>

<script>
import Scantron from "../../components/Exams/Scantron";
import EventBus from "../../services/eventBus/EventBus";
import EventConstants from "../../services/eventBus/EventConstants";
import StoreConstants from "../../store/services/StoreConstants";
import { mapGetters } from "vuex";
import EditExamModal from "../../components/Exams/EditExamModal";

export default {
  name: "Exams",
  components: { EditExamModal, Scantron },
  props: {
    courseId: {
      type: String,
      default: null
    },
    questionCategories: {
      type: Array,
      default: null
    },
    exam: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapGetters({
      isAdmin: StoreConstants.GETTERS.IS_ADMIN
    })
  },
  data: () => ({
    submitError: false
  }),
  mounted: function() {
    EventBus.$on(EventConstants.EVENTS.EXAM_UPDATED, this.submitExam);
  },
  destroyed() {
    EventBus.$off(EventConstants.EVENTS.EXAM_UPDATED);
  },
  methods: {
    submitExam() {
      this.$bvModal.show("editExamModal");
    }
  }
};
</script>

<style scoped>
.indentation-left {
  margin-left: 30px;
  margin-right: 45px;
}
</style>
